/**
 * webauthn-errors/org-admin-messages.ts — org-admin-gated write refusal
 *
 * Split out of messages.ts for the 300-line modularity rule, mirroring the
 * master-messages.ts / keypair-binding-messages.ts / challenge-race-messages.ts
 * precedent, and re-exported into SERVER_ERROR_MESSAGES so `resolveWebAuthnError`
 * needs no separate lookup.
 *
 * ORG_ADMIN_REQUIRED (#2999, ledger #127) — the payment-defaults PUT/DELETE
 * (and their UV ceremony begin route) now 403 an active-but-non-admin staff
 * member (Operator/Viewer) BEFORE any WebAuthn prompt or write. Without this
 * entry the code fell through to the generic FALLBACK_MESSAGE, which told the
 * user "refresh and try again" for a permission they will never gain by
 * retrying — the exact house-rule gap this file closes (client copy driven by
 * the SAME code the server emits, not a hand-maintained guess).
 */

import type { WebAuthnUserMessage } from "./types";

export const ORG_ADMIN_ERROR_MESSAGES: Record<string, WebAuthnUserMessage> = {
  ORG_ADMIN_REQUIRED: {
    title:       "Administrator required",
    description: "Only an organisation administrator can change payment defaults. Ask an admin of this organisation to make this change.",
    retryable:   false,
    severity:    "amber",
  },
};
